// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import axios from "axios";
// import {
//   Table,
//   TableHeader,
//   TableColumn,
//   TableBody,
//   TableRow,
//   TableCell,
//   Chip,
//   Spinner,
//   Pagination,
// } from "@nextui-org/react";
// import { IoMdEye } from "react-icons/io";
// import { toast } from "react-toastify";

// /* ------------------------------------------------------------------ */
// /*  Helpers                                                           */
// /* ------------------------------------------------------------------ */
// function getSupplierId() {
//   try {
//     const details = JSON.parse(localStorage.getItem("user_details") || "{}");
//     return details?.user?.id ?? localStorage.getItem("user_id");
//   } catch {
//     return localStorage.getItem("user_id");
//   }
// }

// function minutesAgo(dateString) {
//   const diffSec = Math.floor((Date.now() - new Date(dateString)) / 1000);
//   if (diffSec < 60) return "Just now";
//   const diffMin = Math.floor(diffSec / 60);
//   if (diffMin < 60) return `${diffMin} min${diffMin > 1 ? "s" : ""} ago`;
//   const diffHr = Math.floor(diffMin / 60);
//   if (diffHr < 24) return `${diffHr} hr${diffHr > 1 ? "s" : ""} ago`;
//   const diffDay = Math.floor(diffHr / 24);
//   return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
// }

// /* ------------------------------------------------------------------ */
// /*  Component                                                         */
// /* ------------------------------------------------------------------ */
// export default function HiddenDataTable() {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // front-end pagination state (6 per page)
//   const [page, setPage] = useState(1);
//   const rowsPerPage = 6;

//   const token = localStorage.getItem("accessToken");

//   // always fetch page=1, pageSize=1000
//   const fetchHiddenRequests = useCallback(async () => {
//     setLoading(true);
//     const supplierId = getSupplierId();
//     if (!supplierId) {
//       setError("Cannot determine supplier id");
//       setLoading(false);
//       return;
//     }
//     try {
//       const qp = new URLSearchParams();
//       qp.append("page", 1);
//       qp.append("pageSize", 1000);

//       const res = await axios.get(
//         `${
//           process.env.REACT_APP_SERVER_URL
//         }/quotes/gethiderequets/${supplierId}?${qp.toString()}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const payload = res.data;
//       const dataRows = payload.data || payload.rows || [];
//       setRows(dataRows);
//     } catch (err) {
//       console.error(err);
//       setError(err.message || "Unknown error");
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   useEffect(() => {
//     fetchHiddenRequests();
//   }, [fetchHiddenRequests]);

//   // compute which 6 rows to show on the current "page"
//   const pagedRows = useMemo(() => {
//     const start = (page - 1) * rowsPerPage;
//     return rows.slice(start, start + rowsPerPage);
//   }, [rows, page]);

//   const totalPages = Math.max(1, Math.ceil(rows.length / rowsPerPage));

//   // const handleHide = async (requestId) => {
//   //   const tId = toast.loading("Un-hiding…");
//   //   try {
//   //     await axios.post(
//   //       `${process.env.REACT_APP_SERVER_URL}/quotes/hiderequest/${requestId}`,
//   //       {},
//   //       { headers: { Authorization: `Bearer ${token}` } }
//   //     );
//   //     await fetchHiddenRequests();
//   //     toast.update(tId, {
//   //       render: "Request un-hidden",
//   //       type: "success",
//   //       isLoading: false,
//   //       autoClose: 3000,
//   //     });
//   //   } catch {
//   //     toast.update(tId, {
//   //       render: "Failed to un-hide",
//   //       type: "error",
//   //       isLoading: false,
//   //       autoClose: 4000,
//   //     });
//   //   }
//   // };

//   const handleHide = async (requestId) => {
//     try {
//       await axios.post(
//         `${process.env.REACT_APP_SERVER_URL}/quotes/hiderequest/${requestId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       await fetchHiddenRequests();
//       toast.success("Request un-hidden", { autoClose: 3000 });
//     } catch {
//       toast.error("Failed to un-hide", { autoClose: 4000 });
//     }
//   };
//   const statusColorMap = useMemo(
//     () => ({ New: "primary", "In progress": "warning", Completed: "success" }),
//     []
//   );

//   if (loading)
//     return (
//       <div className="flex justify-center items-center h-48">
//         <Spinner size="lg" />
//       </div>
//     );
//   if (error) return <div className="p-4 text-red-600">Error: {error}</div>;

//   return (
//     <Table
//       aria-label="Hidden Requests Table"
//       isHeaderSticky
//       isStriped
//       bottomContent={
//         totalPages > 1 && (
//           <div className="py-2 flex justify-center">
//             <Pagination
//               showControls
//               showShadow
//               color="primary"
//               page={page}
//               total={totalPages}
//               onChange={setPage}
//               siblings={0}
//               boundaries={0}
//             />
//           </div>
//         )
//       }
//       bottomContentPlacement="outside"
//       classNames={{
//         thead: "bg-gray-100",
//         th: "text-left text-sm font-medium text-gray-700 px-4 py-2",
//         td: "text-sm text-gray-800 px-4 py-3 whitespace-nowrap",
//       }}
//     >
//       <TableHeader>
//         <TableColumn>Status</TableColumn>
//         <TableColumn>Industry</TableColumn>
//         <TableColumn>Car</TableColumn>
//         <TableColumn>Part</TableColumn>
//         <TableColumn>Created</TableColumn>
//         <TableColumn>UnHide</TableColumn>
//       </TableHeader>
//       <TableBody>
//         {pagedRows.length > 0 ? (
//           pagedRows.map(({ request, User }) => {
//             if (!request) return null;
//             const statusLabel = request.RequestStatus?.status || "Unknown";
//             const statusColor = statusColorMap[statusLabel] || "default";
//             const industryLabel =
//               User?.business_name || User?.Industry || "Private";
//             const make =
//               request.VehicleMake?.name || request.custom_make || "-";
//             const model =
//               request.VehicleModel?.name || request.custom_model || "-";
//             const partLabel =
//               request.custom_part_type || request.Part?.name || "-";
//             const createdAgo = minutesAgo(request.date_requested);
//             const createdDate = new Date(
//               request.date_requested
//             ).toLocaleDateString();

//             return (
//               <TableRow key={request.id} className="hover:bg-gray-50">
//                 <TableCell>
//                   <Chip
//                     variant="flat"
//                     color={statusColor}
//                     className="capitalize"
//                   >
//                     {statusLabel}
//                   </Chip>
//                 </TableCell>
//                 <TableCell>
//                   <span className="font-medium">{industryLabel}</span>
//                 </TableCell>
//                 <TableCell>
//                   <span className="font-semibold">
//                     {`${make} ${model}`.trim()}
//                   </span>
//                 </TableCell>
//                 <TableCell>
//                   <span className="font-semibold capitalize">{partLabel}</span>
//                 </TableCell>
//                 <TableCell>
//                   <div className="flex flex-col">
//                     <span className="font-semibold">{createdAgo}</span>
//                     <span className="text-xs text-gray-500">{createdDate}</span>
//                   </div>
//                 </TableCell>

//                 <TableCell className="text-start pl-8 ">
//                   <button
//                     onClick={(e) => {
//                       e.preventDefault();
//                       handleHide(request.id);
//                     }}
//                   >
//                     <IoMdEye className="text-lg text-blue-500 hover:text-blue-700 "/>
//                   </button>
//                 </TableCell>
//               </TableRow>
//             );
//           })
//         ) : (
//           <TableRow>
//             <TableCell  className="text-center">
//               No Data Found
//             </TableCell>
//           </TableRow>
//         )}
//       </TableBody>
//     </Table>
//   );
// }

// "use client";

// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import axios from "axios";
// import {
//   Table,
//   TableHeader,
//   TableColumn,
//   TableBody,
//   TableRow,
//   TableCell,
//   Chip,
//   Spinner,
//   Pagination,
// } from "@nextui-org/react";
// import { IoMdEye } from "react-icons/io";
// import { toast } from "react-toastify";

// /* ------------------------------------------------------------------ */
// /*  Helpers                                                           */
// /* ------------------------------------------------------------------ */
// function getSupplierId() {
//   try {
//     const details = JSON.parse(localStorage.getItem("user_details") || "{}");
//     return details?.user?.id ?? localStorage.getItem("user_id");
//   } catch {
//     return localStorage.getItem("user_id");
//   }
// }

// function minutesAgo(dateString) {
//   const diffSec = Math.floor((Date.now() - new Date(dateString)) / 1000);
//   if (diffSec < 60) return "Just now";
//   const diffMin = Math.floor(diffSec / 60);
//   if (diffMin < 60) return `${diffMin} min${diffMin > 1 ? "s" : ""} ago`;
//   const diffHr = Math.floor(diffMin / 60);
//   if (diffHr < 24) return `${diffHr} hr${diffHr > 1 ? "s" : ""} ago`;
//   const diffDay = Math.floor(diffHr / 24);
//   return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
// }

// /* ------------------------------------------------------------------ */
// /*  Component                                                         */
// /* ------------------------------------------------------------------ */
// export default function HiddenDataTable() {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [page, setPage] = useState(1);
//   const rowsPerPage = 6;
//   const token = localStorage.getItem("accessToken");

//   const fetchHiddenRequests = useCallback(async () => {
//     setLoading(true);
//     const supplierId = getSupplierId();
//     if (!supplierId) {
//       setError("Cannot determine supplier id");
//       setLoading(false);
//       return;
//     }
//     try {
//       const qp = new URLSearchParams();
//       qp.append("page", 1);
//       qp.append("pageSize", 1000);

//       const res = await axios.get(
//         `${process.env.REACT_APP_SERVER_URL}/quotes/gethiderequets/${supplierId}?${qp.toString()}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const payload = res.data;
//       const dataRows = payload.data || payload.rows || [];
//       setRows(dataRows);
//     } catch (err) {
//       console.error(err);
//       setError(err.message || "Unknown error");
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   useEffect(() => {
//     fetchHiddenRequests();
//   }, [fetchHiddenRequests]);

//   const pagedRows = useMemo(() => {
//     const start = (page - 1) * rowsPerPage;
//     return rows.slice(start, start + rowsPerPage);
//   }, [rows, page]);

//   const totalPages = Math.max(1, Math.ceil(rows.length / rowsPerPage));

//   const handleHide = async (requestId) => {
//     try {
//       await axios.post(
//         `${process.env.REACT_APP_SERVER_URL}/quotes/hiderequest/${requestId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       await fetchHiddenRequests();
//       toast.success("Request un-hidden", { autoClose: 3000 });
//     } catch {
//       toast.error("Failed to un-hide", { autoClose: 4000 });
//     }
//   };

//   const statusColorMap = useMemo(
//     () => ({ New: "primary", "In progress": "warning", Completed: "success" }),
//     []
//   );

//   if (loading)
//     return (
//       <div className="flex justify-center items-center h-48">
//         <Spinner size="lg" />
//       </div>
//     );
//   if (error) return <div className="p-4 text-red-600">Error: {error}</div>;

//   return (
//     <Table
//       aria-label="Hidden Requests Table"
//       isHeaderSticky
//       isStriped
//       bottomContent={
//         totalPages > 1 && (
//           <div className="py-2 flex justify-center">
//             <Pagination
//               showControls
//               showShadow
//               color="primary"
//               page={page}
//               total={totalPages}
//               onChange={setPage}
//               siblings={0}
//               boundaries={0}
//             />
//           </div>
//         )
//       }
//       bottomContentPlacement="outside"
//       classNames={{
//         thead: "bg-gray-100",
//         th: "text-left text-sm font-medium text-gray-700 px-4 py-2",
//         td: "text-sm text-gray-800 px-4 py-3 whitespace-nowrap",
//       }}
//     >
//       <TableHeader>
//         <TableColumn>Status</TableColumn>
//         <TableColumn>Industry</TableColumn>
//         <TableColumn>Car</TableColumn>
//         <TableColumn>Part</TableColumn>
//         <TableColumn>Created</TableColumn>
//         <TableColumn>UnHide</TableColumn>
//       </TableHeader>

//       <TableBody
//         emptyContent={
//           <div className="py-10 text-center text-gray-500 text-sm">
//             No Data Found
//           </div>
//         }
//       >
//         {pagedRows.map(({ request, User }) => {
//           if (!request) return null;

//           const statusLabel = request.RequestStatus?.status || "Unknown";
//           const statusColor = statusColorMap[statusLabel] || "default";
//           const industryLabel =
//             User?.business_name || User?.Industry || "Private";
//           const make = request.VehicleMake?.name || request.custom_make || "-";
//           const model =
//             request.VehicleModel?.name || request.custom_model || "-";
//           const partLabel =
//             request.custom_part_type || request.Part?.name || "-";
//           const createdAgo = minutesAgo(request.date_requested);
//           const createdDate = new Date(
//             request.date_requested
//           ).toLocaleDateString();

//           return (
//             <TableRow key={request.id} className="hover:bg-gray-50">
//               <TableCell>
//                 <Chip
//                   variant="flat"
//                   color={statusColor}
//                   className="capitalize"
//                 >
//                   {statusLabel}
//                 </Chip>
//               </TableCell>
//               <TableCell>
//                 <span className="font-medium">{industryLabel}</span>
//               </TableCell>
//               <TableCell>
//                 <span className="font-semibold">
//                   {`${make} ${model}`.trim()}
//                 </span>
//               </TableCell>
//               <TableCell>
//                 <span className="font-semibold capitalize">{partLabel}</span>
//               </TableCell>
//               <TableCell>
//                 <div className="flex flex-col">
//                   <span className="font-semibold">{createdAgo}</span>
//                   <span className="text-xs text-gray-500">
//                     {createdDate}
//                   </span>
//                 </div>
//               </TableCell>
//               <TableCell className="text-start pl-8">
//                 <button
//                   onClick={(e) => {
//                     e.preventDefault();
//                     handleHide(request.id);
//                   }}
//                 >
//                   <IoMdEye className="text-lg text-blue-500 hover:text-blue-700" />
//                 </button>
//               </TableCell>
//             </TableRow>
//           );
//         })}
//       </TableBody>
//     </Table>
//   );
// }

"use client";

import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Spinner,
  Pagination,
} from "@nextui-org/react";
import { IoMdEye } from "react-icons/io";
import { toast } from "react-toastify";

/* ------------------------------------------------------------------ */
/*  Helpers                                                           */
/* ------------------------------------------------------------------ */
function getSupplierId() {
  try {
    const details = JSON.parse(localStorage.getItem("user_details") || "{}");
    return details?.user?.id ?? localStorage.getItem("user_id");
  } catch {
    return localStorage.getItem("user_id");
  }
}

function minutesAgo(dateString) {
  const diffSec = Math.floor((Date.now() - new Date(dateString)) / 1000);
  if (diffSec < 60) return "Just now";
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} min${diffMin > 1 ? "s" : ""} ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr} hr${diffHr > 1 ? "s" : ""} ago`;
  const diffDay = Math.floor(diffHr / 24);
  return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
}

/* ------------------------------------------------------------------ */
/*  Component                                                         */
/* ------------------------------------------------------------------ */
export default function HiddenDataTable() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [page, setPage] = useState(1);
  const rowsPerPage = 6;
  const token = localStorage.getItem("accessToken");

  const fetchHiddenRequests = useCallback(async () => {
    setLoading(true);
    const supplierId = getSupplierId();
    if (!supplierId) {
      setError("Cannot determine supplier id");
      setLoading(false);
      return;
    }
    try {
      const qp = new URLSearchParams();
      qp.append("page", 1);
      qp.append("pageSize", 1000);

      const res = await axios.get(
        `${
          process.env.REACT_APP_SERVER_URL
        }/quotes/gethiderequets/${supplierId}?${qp.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const payload = res.data;
      const dataRows = payload.data || payload.rows || [];
      setRows(dataRows);

      // ✅ Fix: If current page becomes invalid due to fewer rows, reset page
      const newTotalPages = Math.ceil(dataRows.length / rowsPerPage);
      if (page > newTotalPages) {
        setPage(Math.max(1, newTotalPages));
      }
    } catch (err) {
      console.error(err);
      setError(err.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  }, [token, page]);

  useEffect(() => {
    fetchHiddenRequests();
  }, [fetchHiddenRequests]);

  const pagedRows = useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    return rows.slice(start, start + rowsPerPage);
  }, [rows, page]);

  const totalPages = Math.max(1, Math.ceil(rows.length / rowsPerPage));

  const handleHide = async (requestId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/quotes/hiderequest/${requestId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await fetchHiddenRequests();
      toast.success("Request un-hidden", { autoClose: 3000 });
    } catch {
      toast.error("Failed to un-hide", { autoClose: 4000 });
    }
  };

  const statusColorMap = useMemo(
    () => ({ New: "primary", "In progress": "warning", Completed: "success" }),
    []
  );

  if (loading)
    return (
      <div className="flex justify-center items-center h-48">
        <Spinner size="lg" />
      </div>
    );
  if (error) return <div className="p-4 text-red-600">Error: {error}</div>;

  return (
    <Table
      aria-label="Hidden Requests Table"
      isHeaderSticky
      isStriped
      bottomContent={
        totalPages > 1 && (
          <div className="py-2 flex justify-center">
            <Pagination
              showControls
              showShadow
              color="primary"
              page={page}
              total={totalPages}
              onChange={setPage}
              siblings={0}
              boundaries={0}
            />
          </div>
        )
      }
      bottomContentPlacement="outside"
      classNames={{
        thead: "bg-gray-100",
        th: "text-left text-sm font-medium text-gray-700 px-4 py-2",
        td: "text-sm text-gray-800 px-4 py-3 whitespace-nowrap",
      }}
    >
      <TableHeader>
        <TableColumn>Status</TableColumn>
        <TableColumn>Industry</TableColumn>
        <TableColumn>Car</TableColumn>
        <TableColumn>Part</TableColumn>
        <TableColumn>Created</TableColumn>
        <TableColumn>UnHide</TableColumn>
      </TableHeader>

      <TableBody
        emptyContent={
          <div className="py-10 text-center text-gray-500 text-sm">
            No Data Found
          </div>
        }
      >
        {pagedRows.map(({ request, User }) => {
          if (!request) return null;

          const statusLabel = request.RequestStatus?.status || "Unknown";
          const statusColor = statusColorMap[statusLabel] || "default";
          const industryLabel =
            User?.business_name || User?.Industry || "Private";
          const make = request.VehicleMake?.name || request.custom_make || "-";
          const model =
            request.VehicleModel?.name || request.custom_model || "-";
          const partLabel =
            request.custom_part_type || request.Part?.name || "-";
          const createdAgo = minutesAgo(request.date_requested);
          const createdDate = new Date(
            request.date_requested
          ).toLocaleDateString();

          return (
            <TableRow key={request.id} className="hover:bg-gray-50">
              <TableCell>
                <Chip variant="flat" color={statusColor} className="capitalize">
                  {statusLabel}
                </Chip>
              </TableCell>
              <TableCell>
                <span className="font-medium">{industryLabel}</span>
              </TableCell>
              <TableCell>
                <span className="font-semibold">
                  {`${make} ${model}`.trim()}
                </span>
              </TableCell>
              <TableCell>
                <span className="font-semibold capitalize">{partLabel}</span>
              </TableCell>
              <TableCell>
                <div className="flex flex-col">
                  <span className="font-semibold">{createdAgo}</span>
                  <span className="text-xs text-gray-500">{createdDate}</span>
                </div>
              </TableCell>
              <TableCell className="text-start pl-8">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleHide(request.id);
                  }}
                >
                  <IoMdEye className="text-lg text-blue-500 hover:text-blue-700" />
                </button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
